import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import { Padding } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";
import moment from 'moment';
import 'moment/locale/si';
import "moment-precise-range-plugin"; // Import the plugin to extend moment

function HCViewDKDasa({ tableData }) {
    const { t } = useTranslation();
    const lang = localStorage.getItem('language') || 'si';

    moment.locale(lang); // Set the locale based on the selected language
    const dataTableData = {
        columns: [
            { Header: t("DASAWA"), accessor: "dasaL1", width: "10%"},
            { Header: t("ATHURUDASA"), accessor: "dasaL2", width: "10%"},
            { Header: t("VIDASA"), accessor: "dasaL3", width: "10%"},
            {
                Header: "", accessor: "dasaLevel", width: "10%",
                Cell: ({ row }) => <MDButton variant="text" color="info" size="small">
                    {row.values.dasaLevel == 2 && <pre>&#9;&#9;&#9;&#9;</pre>}
                    {row.values.dasaLevel == 3 && <pre>&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;</pre>}
                    {row.values.dasaLevel < 3 && <span
                        {...row.getToggleRowExpandedProps()}>
                        {row.isExpanded && <Icon>expand_less</Icon>}
                        {!row.isExpanded && <Icon>expand_more</Icon>}
                    </span>}
                    {row.values.dasaLevel == 1 && <pre>{t('MAHADASA')}</pre>}
                    {row.values.dasaLevel == 2 && <pre>{t('ATHURUDASA')}</pre>}
                    {row.values.dasaLevel == 3 && <pre>{t('VIDASA')}</pre>}
                </MDButton>
            },
            { Header: t("From"), accessor: "from", width: "20%"},
            { Header: t("To"), accessor: "to"},
             { Header: "", accessor: "duration"},
        ],
        rows: tableData,
        rowStyles:  (dasaLevel) =>  
                {
                return     {
                    backgroundColor: dasaLevel === 1 ? '#ffe6e6' : 'white',
                }
            
        }
    }

    return (
        <MDBox pt={0} pb={1}>
            <MDBox mb={1}>
                <Card>
                    {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                        <MDTypography variant="h5" fontWeight="medium">
                            දසා
                        </MDTypography>
                        <Divider  variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                    </MDBox> */}
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData}
                        canExpanded={true}                        
                        />
                </Card>
            </MDBox>
        </MDBox>
    );
};

HCViewDKDasa.propTypes = {
    tableData: PropTypes.array,
    row: PropTypes.shape({
        getToggleRowExpandedProps: PropTypes.func.isRequired,
        isExpanded: PropTypes.bool.isRequired,
        subRows: PropTypes.array,
        values: PropTypes.any,
        dasaLevel: PropTypes.number,
        original: PropTypes.shape({
            dasaLevel: PropTypes.string.isRequired})
    }),
};

export default HCViewDKDasa;